import { Check, X, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

export type ProtocolStatus = "no_hecho" | "parcial" | "completado" | null;

interface ProtocolStatusSelectorProps {
  status: ProtocolStatus;
  onChange: (status: ProtocolStatus) => void;
}

export const ProtocolStatusSelector = ({ status, onChange }: ProtocolStatusSelectorProps) => {
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground">Protocolo del día</h3>
      <div className="grid grid-cols-1 gap-2">
        <button
          onClick={() => onChange("no_hecho")}
          className={cn(
            "flex items-center gap-3 w-full px-4 py-3.5 rounded-xl border transition-all text-sm font-medium",
            status === "no_hecho" 
              ? "border-destructive/50 bg-destructive/5 text-destructive" 
              : "border-border bg-background hover:border-destructive/30 text-foreground"
          )}
        >
          <div className={cn(
            "w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all",
            status === "no_hecho" ? "border-destructive bg-destructive text-white" : "border-muted-foreground"
          )}>
            {status === "no_hecho" && <X className="h-3 w-3" />}
          </div>
          No lo hice
        </button>

        <button
          onClick={() => onChange("parcial")}
          className={cn(
            "flex items-center gap-3 w-full px-4 py-3.5 rounded-xl border transition-all text-sm font-medium",
            status === "parcial" 
              ? "border-amber-500/50 bg-amber-500/5 text-amber-600" 
              : "border-border bg-background hover:border-amber-500/30 text-foreground"
          )}
        >
          <div className={cn(
            "w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all",
            status === "parcial" ? "border-amber-500 bg-amber-500 text-white" : "border-muted-foreground"
          )}>
            {status === "parcial" && <Minus className="h-3 w-3" />}
          </div>
          Completado parcialmente
        </button>

        <button
          onClick={() => onChange("completado")}
          className={cn(
            "flex items-center gap-3 w-full px-4 py-3.5 rounded-xl border transition-all text-sm font-medium",
            status === "completado" 
              ? "border-primary bg-primary/10 text-primary-dark" 
              : "border-border bg-background hover:border-primary/40 text-foreground"
          )}
        >
          <div className={cn(
            "w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all",
            status === "completado" ? "border-primary bg-primary text-primary-foreground" : "border-muted-foreground"
          )}>
            {status === "completado" && <Check className="h-3 w-3" />}
          </div>
          Completado
        </button>
      </div>
    </div>
  );
};
